
/**
 * 콘텐츠 타입
 */
export type GetCourseDraftById200SectionsItemLecturesItemContentType = typeof GetCourseDraftById200SectionsItemLecturesItemContentType[keyof typeof GetCourseDraftById200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
